export default __webpack_public_path__ + "static/media/shuk.190c29bd.jpg";